// src/components/AddIgnoreDialog.tsx
import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Select,
    MenuItem,
    TextField,
    Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { validateEmail, validateDomain } from "../utils/validation";

interface AddIgnoreDialogProps {
    open: boolean;
    onClose: () => void;
    onSave: (type: string, value: string) => void;
    initialType?: string;
    initialValue?: string;
}

const AddIgnoreDialog: React.FC<AddIgnoreDialogProps> = ({ open, onClose, onSave, initialType = "Domain", initialValue = "" }) => {
    const { t } = useTranslation();
    const [type, setType] = useState(initialType);
    const [value, setValue] = useState(initialValue);
    const [error, setError] = useState(false);
    const [helperText, setHelperText] = useState("");

    useEffect(() => {
        setType(initialType);
        setValue(initialValue);
        setError(false);
        setHelperText("");
    }, [open, initialType, initialValue]);

    const handleBlur = () => {
        if (type === "Email" && !validateEmail(value)) {
            setError(true);
            setHelperText("Invalid email format");
        } else if (type === "Domain" && !validateDomain(value)) {
            setError(true);
            setHelperText(t("Invalid domain format"));
        } else {
            setError(false);
            setHelperText("");
        }
    };

    const handleSave = () => {
        handleBlur();
        if (!error) onSave(type, value);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{t(initialValue ? "Edit Item" : "Add Item")}</DialogTitle>
            <DialogContent>
                <Select fullWidth value={type} onChange={(e) => setType(e.target.value)}>
                    {["Domain", "Email"].map((it) => (
                        <MenuItem key={it} value={it}>{t(it)}</MenuItem>
                    ))}
                </Select>
                <TextField
                    label={t("Value")}
                    fullWidth
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onBlur={handleBlur}
                    margin="dense"
                    error={error}
                    helperText={helperText}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("Cancel")}</Button>
                <Button onClick={handleSave}>{t("Save")}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddIgnoreDialog;
